<template>
	<div>
		<!-- note below div contains audio style -->
		<div class="secsub-left-quescontainer">
			<div class="sec-quescard d-flex flex-column">
				<div
					class="sec-quescardonopen-header d-flex mb-1 align-items-center justify-content-between"
					v-if="showansweroptions"
					@click="showansweroptions = !showansweroptions"
				>
					<div class="sec-quescard-headtext">MCQ</div>
					<div class="d-flex pointer">
						<div
							:class="isLocked ? 'disableSharing' : ''"
							v-if="roles.includes('PUT_QUESTION')"
							@click.stop="
								!isLocked ? ((editModal = !editModal), copyingVal()) : null
							"
							class="mr-3"
						>
							<img
								v-b-popover.hover.top="'Edit'"
								src="../../assets/editicon.svg"
								alt=""
							/>
						</div>
						<div
							:class="isLocked ? 'disableSharing' : ''"
							v-if="roles.includes('DELETE_QUESTION')"
							@click.stop="!isLocked ? (deleteModal = !deleteModal) : null"
							class="mr-3"
						>
							<img
								v-b-popover.hover.top="'Delete'"
								src="../../assets/deleteicon.svg"
								alt=""
							/>
						</div>
						<div>
							<img src="../../assets/uparrow.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="d-flex relativeclass">
					<div class="mcqcard-colorbar mt-1"></div>
					<div
						class="ml-3 align-items-center pointer"
						style="width: 95%; padding: 10px 0"
						@click="showansweroptions = true"
					>
						<div class="sec-quescard-headtext" v-if="!showansweroptions">
							MCQ
						</div>

						<div class="sec-ques-style relativeclass">
							<template v-if="!showansweroptions">
								<div class="d-flex">
									<div style="white-space: nowrap">Q{{ showindex }}.</div>
									<div
										class="topicDescBreak ml-1"
										v-html-safe="$options.filters.MMQfilter(data.question)"
									></div>
								</div>
							</template>
							<template v-else>
								<div class="relativeclass">
									<div class="d-flex">
										<div style="white-space: nowrap">Q{{ showindex }}.</div>
										<div
											class="ml-1 topicDescBreak"
											v-html-safe="data.question"
										></div>
									</div>

									<template
										v-if="'questionMedia' in data && data.questionMedia != null"
									>
										<div
											v-if="isImage(data.questionMediaType)"
											class="mt-2 mb-2 d-flex align-items-center justify-content-center"
										>
											<div class="relativeclass">
												<img
													:src="data.questionMedia"
													alt=""
													class="dbmcqcardimage"
												/>
											</div>
										</div>

										<!-- below div comes if audio exists -->
										<div
											v-if="isAudio(data.questionMediaType)"
											class="d-flex mt-2 mb-2 align-items-center justify-content-center"
										>
											<div>
												<Media
													:kind="'audio'"
													:isMuted="false"
													:autoplay="false"
													:controls="true"
													:loop="true"
													class="mcqdatacard-audio"
													:src="data.questionMedia"
												></Media>
											</div>
										</div>
										<div
											v-if="isVideo(data.questionMediaType)"
											class="d-flex mt-2 mb-2 align-items-center justify-content-center"
										>
											<div class="relativeclass">
												<Media
													:kind="'video'"
													:isMuted="false"
													:src="data.questionMedia"
													:autoplay="false"
													:controls="true"
													:loop="true"
													class="dbmcqcardimage"
												></Media>
											</div>
										</div>
									</template>
								</div>
								<b-row class="">
									<b-col
										v-for="(i, index) in data.options"
										:key="index"
										class="d-flex"
										cols="6"
										:class="{
											'mt-3': index > 1,
										}"
									>
										<div class="ml-3" v-if="showansweroptions">
											<div
												v-if="data.noOfCorrectOptionsAllowed > 1"
												class="mcq-checkbox"
											>
												<b-form-checkbox
													v-model.trim="i.check"
													name="some-radios"
													disabled
												>
													<span v-if="i.value"> {{ i.value }}</span>
													<span v-if="i.media">
														<span class="uploaded-option-imagecard">
															<img
																:src="i.media"
																alt=""
																class="w-100 h-100 overflow-hidden"
																style="border-radius: 4px;"
															/>
														</span>
													</span>
												</b-form-checkbox>
											</div>
											<div
												v-else
												:class="
													i.check == true
														? 'sec-ques-green'
														: ' sec-questions-radios'
												"
											>
												<b-form-radio
													name="some-radios"
													class="sec-ques-style"
													v-model="selected"
													disabled
													><span v-if="i.value"> {{ i.value }}</span>
													<span v-if="i.media">
														<span class="uploaded-option-imagecard">
															<img
																:src="i.media"
																alt=""
																class="w-100 h-100 overflow-hidden"
																style="border-radius: 4px;"
															/>
														</span> </span
												></b-form-radio>
											</div>
										</div>
									</b-col>
								</b-row>
								<div
									class="d-flex"
									style="width: 100%"
									v-if="data.questionTags.length > 0"
								>
									<div style="width: 80%">
										<div class="d-flex flex-wrap ml-3">
											<div
												class="view-questags pl-2 pr-2 pt-1 pb-1 mr-2 mt-2"
												v-for="qt in questionTags"
												:key="qt"
												v-b-popover.hover.top="qt"
											>
												{{ qt | fnName }}
											</div>
										</div>
									</div>
									<b-input-group-append
										v-if="data.questionTags.length > 6 && questagmore"
										@click="changequestagmore()"
										style="width: 20%"
										class="text-center mt-1"
									>
										<div type="button" class="questag-more-btn">view more</div>
									</b-input-group-append>
									<b-input-group-append
										class="text-center mt-1"
										v-if="data.questionTags.length > 6 && questagmore == false"
										@click="changequestagmore()"
										tyle="width:20%"
									>
										<div type="button" class="questag-more-btn">view less</div>
									</b-input-group-append>
								</div>

								<template v-if="data.questionTags.length > 0">
									<hr class="ml-3" />
								</template>
								<div class="d-flex align-items-center mt-2">
									<div
										class="card-req-show mr-2"
										v-if="data.questionConfig.autoCorrection"
									>
										<img
											src="../../assets/rightmark.svg"
											alt=""
											class="mr-2"
										/>Auto Evaluation
									</div>
									<div
										class="card-req-show"
										v-if="data.questionConfig.required"
									>
										<img
											src="../../assets/rightmark.svg"
											alt=""
											class="mr-2"
										/>Required
									</div>
								</div>
							</template>
						</div>

						<div class="sec-icons-style d-flex align-items-center">
							<template
								v-if="
									'questionMedia' in data &&
										data.questionMedia != null &&
										!showansweroptions
								"
							>
								<div
									v-if="isImage(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/image.svg" alt="" />
									<span class="ml-2">Image</span>
								</div>
								<div
									v-if="isAudio(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/audio.svg" alt="" />
									<span class="ml-2">Audio</span>
								</div>
								<div
									v-if="isVideo(data.questionMediaType)"
									class="d-flex align-items-center"
								>
									<img src="../../assets/vedio.svg" alt="" />
									<span class="ml-2">Video</span>
								</div>
							</template>
						</div>
					</div>
					<div
						class="d-flex align-items-center pointer mcqcard-downarrow"
						style="width: 3%"
						@click="(showansweroptions = !showansweroptions), copyingVal()"
					>
						<img
							src="../../assets/downarrow.svg"
							alt=""
							v-if="!showansweroptions"
						/>
					</div>
					<div class="display-mcqcard-mark-tag d-flex align-items-center mt-2">
						<div class="display-card-mark-text">Marks</div>
						<div class="display-card-mark-number ml-2">{{ data.marks }}</div>
					</div>
				</div>
			</div>
		</div>

		<!-----------------  Delete Popup starts -------->
		<b-modal
			id="deleteTopicModal"
			v-model="deleteModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="closedeletemodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete the selected question?</span>
			</div>
			<div class="caution-modal-text">
				<b-form-group label="Delete from" v-slot="{ ariaDescribedby }">
					<b-form-radio
						v-model="selected"
						:aria-describedby="ariaDescribedby"
						name="some-radios"
						value="A"
						>Test only</b-form-radio
					>
					<b-form-radio
						v-model="selected"
						:aria-describedby="ariaDescribedby"
						name="some-radios"
						value="B"
						>Test and Questionbank</b-form-radio
					>
				</b-form-group>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>

			<div
				@click="deleteMcq()"
				class="d-flex align-items-center justify-content-end mt-3"
			>
				<b-button class="addbtn">Delete</b-button>
			</div>
		</b-modal>

		<!-----------------  Delete Popup ends -------->

		<!-- Edit MCQ question Modal Starts -->
		<b-modal
			id="modal-mcq-add"
			v-model="editModal"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
			size="xl"
		>
			<div class="modalheading">Edit MCQ</div>
			<div @click="closeEditmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div :class="{ 'form-disabled': isUploadLocked }">
				<div class="qb-match-options-overflow" ref="mcqModalContent">
					<b-row>
						<b-col>
							<div class="topDiv mt-3 relativeclass questypedisable">
								<label class="fieldsetStyle"
									>Question Type &nbsp;<span class="asterik">*</span></label
								>
								<b-form-input
									type="text"
									placeholder="MCQ's"
									class="edit-disabledinputfield"
									disabled
								></b-form-input>
							</div>
						</b-col>
						<b-col>
							<div class="topDiv mt-3 relativeclass">
								<label class="fieldsetStyle"
									>Marks Alloted&nbsp;<span class="asterik">*</span></label
								>
								<b-form-input
									class="edit-inputfield pr-35"
									v-model="$v.clone.marks.$model"
									placeholder="Marks"
									:class="{
										error: $v.clone.marks.$error,
									}"
									@keypress="validateMarks($event)"
								></b-form-input>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="$v.clone.marks.$dirty && !$v.clone.marks.required"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="!$v.clone.marks.alpha && $v.clone.marks.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Accepts only 2 digit after decimal point',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="!$v.clone.marks.between && $v.clone.marks.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Should be between (0.5, 100)',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</b-col>
					</b-row>
					<b-row class="questiontagcontainer">
						<b-col cols="6">
							<div class="topDiv mt-4 qb-other-textDIff" ref="qpdropdiff1">
								<label class="fieldsetStyle"
									>Difficulty Level<span class="asterik">*</span></label
								>
								<div
									class="editquesdropdown d-flex justify-content-between pointer"
									@click="qbdropdiff = !qbdropdiff"
								>
									<span>Difficulty Level {{ clone.difficultyLevel }}</span>
									<span>
										<img
											v-if="!qbdropdiff"
											src="../../assets/assess-main-downArrow.svg"
											alt=""
											class="mr-1"
										/>
										<img
											v-else
											class="mr-1"
											src="../../assets/assess-main-upArrow.svg"
											alt=""
										/>
									</span>
								</div>
								<div
									v-if="qbdropdiff"
									class="qb-dropdown-option-add d-flex"
									ref="qbdropdiff"
									v-closable="{
										exclude: ['qbdropdiff', 'qpdropdiff1'],
										handler: 'hidediffoptions',
									}"
								>
									<b-form-group
										class="qb-dd-group-diff"
										v-slot="{ ariaDescribedby }"
									>
										<b-form-radio-group
											@change="qbdropdiff = !qbdropdiff"
											class="qb-add-drop width-full"
											id="btn-radios-4"
											v-model="$v.clone.difficultyLevel.$model"
											:options="options"
											:aria-describedby="ariaDescribedby"
											name="radio-btn-stacked"
											buttons
											stacked
											:class="{
												error: $v.clone.difficultyLevel.$error,
											}"
										></b-form-radio-group>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												$v.clone.difficultyLevel.$dirty &&
													!$v.clone.difficultyLevel.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</b-form-group>
								</div>
							</div>
						</b-col>
						<b-col cols="6">
							<div class="topDiv mt-4 ckeditor">
								<label class="addquesboxfieldsetStyle"> Question Tags</label>
								<b-form-tags
									v-model="clone.questionTags"
									no-outer-focus
									separator=" "
									remove-on-delete
								>
									<template
										v-slot="{
											tags,
											inputAttrs,
											inputHandlers,
											tagVariant,
											removeTag,
											addTag,
										}"
									>
										<b-input-group class="mb-2" id="mcqaddcontainer-tag">
											<div
												style="width: 90%"
												class="qb-transparent d-flex cust-group-input"
											>
												<div
													class="d-inline-block cust-btn-select mt-2"
													style="font-size: 1.5rem"
												>
													<b-form-tag
														v-for="tag in tags"
														@remove="removeTag(tag)"
														:key="tag"
														:title="tag"
														:variant="tagVariant"
														class="ml-1"
														>{{ tag }}</b-form-tag
													>
												</div>
												<b-form-input
													id="input-tag-edit"
													v-bind="inputAttrs"
													v-on="inputHandlers"
													@keyup="hashtag()"
													placeholder="Enter Question tag"
													style="border-bottom: unset"
													class="form-control min-width mr-4 ml-2"
												></b-form-input>
											</div>
											<b-input-group-append>
												<b-button
													@click="addTag()"
													variant="outline"
													class="cursor-pointer"
												>
													<img src="../../assets/addicongraywhite.svg" alt="" />
												</b-button>
											</b-input-group-append>
										</b-input-group>
									</template>
								</b-form-tags>
							</div>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12">
							<div class="topDiv mt-3 relativeclass">
								<div
									:class="
										// dirtyMcqQuestion && clone.question == '' ? 'error' : ''
										dirtyMcqQuestion ||
										(!$v.clone.question.maxLength && !dirtyMcqQuestion)
											? 'error'
											: ''
									"
								>
									<label class="addquesboxfieldsetStyle" style="z-index: 5">
										Question &nbsp;<span class="asterik">*</span></label
									>

									<QuillEditor
										:addquesProp="addques"
										:value="$v.clone.question.$model"
										@validationVal="validateText"
										@questionText="updateQuestionContent"
										@addquesBack="changedaddQues"
									></QuillEditor>

									<div
										style="position: absolute; top: 5px; right: 3vw"
										v-if="dirtyMcqQuestion && $v.clone.question.required"
										v-b-popover.hover.top.v-danger="{
											content: 'Required',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>

									<div
										style="position: absolute; top: 5px; right: 3vw"
										v-if="!$v.clone.question.maxLength && !dirtyMcqQuestion"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 10000 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>

								<div class="media-box mt-2 align-items-center">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="d-flex align-items-center">
											<div class="media-text ml-3">Add Media</div>
											<div class="ml-2">
												<img src="../../assets/vertical-line.svg" alt="" />
											</div>
											<div class="d-flex align-items-center ml-2 mt-1">
												<div
													class="ml-2"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Audio supported formats are: wav, mp3"
												>
													<label for="file-uploadedit" class="pointer">
														<img src="../../assets/headphone.svg" alt="" />
													</label>
													<input
														id="file-uploadedit"
														type="file"
														accept="audio/*"
														@change="previewFile"
													/>
												</div>
												<div
													class="ml-3"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Video supported  formats is: mp4"
												>
													<label for="file-upload-videoedit" class="pointer">
														<img src="../../assets/videocam.svg" alt="" />
													</label>
													<input
														id="file-upload-videoedit"
														type="file"
														accept="video/*"
														@change="previewFile"
													/>
												</div>
												<div
													class="ml-3"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													title="Image supported  formats are: jpg, jpeg, png"
												>
													<label for="file-upload-imageedit" class="pointer">
														<img src="../../assets/image-capture.svg" alt="" />
													</label>
													<input
														id="file-upload-imageedit"
														type="file"
														accept="image/*"
														@change="previewFile"
													/>
												</div>
											</div>
										</div>
										<div
											class="d-flex align-items-center"
											v-if="clone.isFailed == true"
										>
											<img src="../../assets/Vector.svg" alt="" class="mr-2" />
											<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
										</div>
									</div>
								</div>
								<div
									style="position: absolute; top: 5px; right: 3vw"
									v-if="dirtyMcqQuestion && !$v.clone.question.required"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</b-col>
						<b-col cols="12">
							<template
								v-if="
									'questionMedia' in clone &&
										clone.questionMedia != null &&
										this.checkMedia == true
								"
							>
								<div class="mt-4 mediaPosition">
									<div class="relativeclass">
										<div @click="removeMedia()" class="qb-cancel-image">
											<img src="../../assets/CloseImg.svg" alt="" />
										</div>
										<div
											class="dbmcqcardimage"
											v-if="isImage(clone.questionMediaType)"
										>
											<img
												:src="clone.questionMedia"
												alt=""
												class="w-100 h-100"
											/>
										</div>

										<div v-if="isAudio(clone.questionMediaType)">
											<Media
												:kind="'audio'"
												:isMuted="false"
												:src="clone.questionMedia"
												:autoplay="false"
												:controls="true"
												:loop="true"
												width="70%"
												class="qb-audio-preview"
											></Media>
										</div>
										<div v-if="isVideo(clone.questionMediaType)">
											<Media
												:kind="'video'"
												:isMuted="false"
												:src="clone.questionMedia"
												:autoplay="false"
												:controls="true"
												:loop="true"
												width="70%"
												height="30%"
												class="qb-vedio-preview"
											></Media>
										</div>
									</div>
								</div>
							</template>
						</b-col>
					</b-row>
					<b-row v-if="showVideoUploading">
						<b-col class="ab-uploaded-card w-100 mt-3">
							<b-card no-body class="d-flex w-100">
								<section class="d-flex align-items-center pt-1">
									<div
										class="ab-uploaded-file-heading d-flex align-items-center w-75"
									>
										{{ videoData.name }}
									</div>

									<div
										class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
									>
										<b-spinner v-if="showSpinner" label="Spinning"></b-spinner>
										<span>{{ formatSize(videoData.size) }}</span>
										<!-- <span class="ml-2"> 2 sec Left</span> -->
									</div>
									<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
								</section>
								<section class="mt-2">
									<b-progress height="4px" :value="progress"></b-progress>
								</section>
							</b-card>
						</b-col>
					</b-row>
					<div
						class="mt-2 ml-3 mb-4 sec-quesbox-radios sec-addquesbox-rightside-questionbank"
					>
						<b-row class="p-2 align-items-end">
							<b-col
								cols="6"
								v-for="(i, index) in clone.options"
								:key="index"
								:class="{
									'mt-3': index > 1,
								}"
							>
								<div class="relativeclass d-flex align-items-end">
									<div
										class="mcq-checkbox"
										:class="{
											'mt-40px': optionPreviews[index],
										}"
									>
										<b-form-checkbox
											v-model.trim="i.check"
											@change="icheck"
											name="some-radios"
										></b-form-checkbox>
									</div>
									<div class="position-relative w-100">
										<b-form-input
											:placeholder="`Enter option ${index + 1}`"
											v-model.trim="i.value"
											:class="i.media === '' ? '' : 'h-150px'"
											:disabled="i.media !== ''"
										>
										</b-form-input>
										<div v-if="optionPreviews[index]">
											<div
												class="uploaded-option-image"
												@mouseover="showoptionImageicons = index"
												@mouseleave="showoptionImageicons = null"
											>
												<img
													:src="optionPreviews[index]"
													alt=""
													class="w-100 h-100 overflow-hidden"
													style="border-radius: 4px;"
												/>
												<div
													v-if="showoptionImageicons === index"
													class="image-blur-overlay"
												></div>
												<div
													class="align-items-center mcq-image-option-hovered-icons"
													v-if="showoptionImageicons === index"
												>
													<img
														src="../../assets/icons/Qpbuilder/imagepreview.svg"
														alt=""
														class="pointer"
														@click.stop.prevent="
															openPreview(optionPreviews[index])
														"
													/>
													<img
														src="../../assets/icons/Qpbuilder/imageclose.svg"
														alt=""
														class="pointer ml-2"
														@click.stop="removeOptionImage(i, index)"
													/>
												</div>
											</div>
										</div>
									</div>
									<div
										:class="
											clone.options.length > 2 && i.check != true
												? 'option-validation-icon'
												: 'option-validation-icon1'
										"
										v-if="
											$v.clone.options.$each[index].value.$dirty &&
												!$v.clone.options.$each[index].value
													.valueOrMediaRequired
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										style="position: absolute; top: 5px; right: -1vw"
										v-if="
											!$v.clone.options.$each[index].value.maxLength &&
												$v.clone.options.$each[index].value.required
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Should not exceed 1024 characters',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										class="mcq-radio-option-delete"
										v-if="clone.options.length > 2 && i.check != true"
									>
										<img
											class="pointer"
											src="../../assets/graydelete.svg"
											alt=""
											@click="deleteOptions(index)"
										/>
									</div>
									<div>
										<label
											:for="`file-upload-imageedit-${index}`"
											class="pointer"
										>
											<img
												:class="{
													right27px:
														clone.options.length > 2 && i.check != true,
												}"
												class="mcq-radio-option-image"
												src="../../assets/icons/Qpbuilder/optionimage.svg"
												alt=""
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Image supported formats are: jpg, jpeg, png"
											/>
										</label>
										<input
											:id="`file-upload-imageedit-${index}`"
											type="file"
											accept="image/*"
											@change="previewOptionfile($event, index)"
											style="display: none"
										/>
									</div>
								</div>
								<div
									style="position: absolute; top: 5px; right: 12px"
									v-if="singletick"
									v-b-popover.hover.top.v-danger="{
										content: 'Select an option',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</b-col>
						</b-row>
						<div
							style="position: absolute; top: 50px"
							v-if="singletick"
							v-b-popover.hover.top.v-danger="{
								content: 'Select an option',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="asterik" v-if="moreOption">
					Cannot add more than 8 options<span class="asterik">*</span>
				</div>

				<div
					class="sec-addquescheckboxcontainer m-3 d-flex justify-content-between"
				>
					<div class="d-flex align-items-center">
						<div
							@click="addOptions()"
							class="d-flex align-items-center pointer mb-3"
						>
							<img src="../../assets/secplusicon.svg" alt="" />
							<div class="sec-addquestext ml-2">Add more options</div>
						</div>
						<b-form-checkbox
							class="ml-3 sec-checboxtext"
							v-model="clone.autoCorrection"
						>
							Auto Evaluation
						</b-form-checkbox>
						<b-form-checkbox
							class="ml-3 sec-checboxtext"
							v-model="clone.required"
						>
							Required
						</b-form-checkbox>
					</div>
					<div class="d-flex pointer relativeclass align-items-center">
						<div class="sec-addcheckboxtext mr-3">
							<span @click="UpdateData()">Update</span>
						</div>

						<div
							v-if="editshowdatacard"
							ref="showdatacard"
							v-closable="{
								exclude: ['showdatacard', 'showdatacard1'],
								handler: 'hideshowcard',
							}"
						>
							<div class="edit-datacards d-flex align-items-center">
								<b-form-group class="sec-mcq-datacard">
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="clone.addToDatabank"
										name="flavour-4a"
									>
										Add to Databank
									</b-form-checkbox>
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="clone.addToPublic"
										name="flavour-4a"
									>
										Add to Public
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<!-- Edit MCQ question Ends -->

		<!-- Upload Modal start -->
		<b-modal
			id="attachdocs"
			v-model="attachdocs"
			centered
			hide-footer
			hide-header
			@show="resetModal"
			@hidden="resetModal"
		>
			<div @click="closeattachdocsmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="relativeclass sec-attachdocs">
				<div class="dot-main">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
							<div>
								<label for="file-upload" class="custom-file-upload pointer">
									<div>
										<img
											src="../../assets/icons/Qpbuilder/uploadicon.svg"
											alt=""
										/>
									</div>
									Click to browse or drag <br />and drop your files
								</label>
								<input id="file-upload" type="file" @change="previewFile" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<!-- Upload Modal end -->

		<b-modal
			id="confirm-edit-modal"
			v-model="editConfirm"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			class="qb-add-ques-modal"
		>
			<b-overlay
				id="overlay-background"
				:show="LoaderStatus"
				variant="white"
				:opacity="overlayOpacity"
				:blur="overlayBlur"
				rounded="sm"
			>
				<div
					class="modalheading d-flex align-items-center justify-content-between"
				>
					Caution !
					<img class="pr-3" src="../../assets/caution.svg" alt="" />
				</div>
				<div @click="closelongEditmModal()" class="xMarkCancel-confirm">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<hr />
				<div v-if="!createnew">
					<div class="mt-3 caution-modal-text">
						<span>Are you sure you want to update ?</span>
					</div>
					<div class="mt-2 caution-modal-text">
						This question is tagged to more than one test. Do you want to create
						a new question or confirm the action?
					</div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button class="addbtn mr-2" @click="createNew()"
							>Create New</b-button
						>
						<div class="sec-canceltext pointer" @click="confirm()">Confirm</div>
					</div>
				</div>
				<div class="caution-modal-text" v-else>
					<div class="modalheading mb-2">
						<img
							src="../../assets/icons/Reports/bckarrow.svg"
							alt=""
							class="mb-1 pointer"
							@click="createnew = false"
						/>
						Create New
					</div>
					Are you sure you want to create new question ?
					<div class="mt-2 normaltext">
						<span class="asterik">*</span
						><span>Please note this action cannot be undone</span>
					</div>
					<div class="d-flex align-items-center justify-content-end mt-3">
						<b-button class="addbtn mr-2" @click="createwith()"
							>Create New With Existing</b-button
						>
						<div class="sec-canceltext pointer" @click="createwithout()">
							Create New & Delete Existing
						</div>
					</div>
				</div>
			</b-overlay>
		</b-modal>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="isImageModalOpen"
		>
			<div class="">
				<img
					:src="previewImage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewImage"
				/>
			</div>
		</b-modal>
		<div
			v-if="isImageModalOpen"
			@click="isImageModalOpen = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/icons/Qpbuilder/imageclose2.svg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
import QuillEditor from "../forms/quillEditor.vue"; //Quill editor from component
import Media from "@dongido/vue-viaudio";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";
import {
	required,
	maxLength,
	helpers,
	between,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import toast from "../../views/mixin/toast";
import {
	postMCQquestionv2,
	putMCQquestionv2,
	deleteMCQquestion,
	deleteTestQuesData,
} from "../../utils/apiFunctions";
const valueOrMediaRequired = helpers.withParams(
	{ type: "valueOrMediaRequired" },
	function(value, parentVm) {
		return !!value || !!parentVm.media;
	}
);
export default {
	name: "MCQCard",
	mixins: [toast, socketUploadMixin],
	data() {
		return {
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			previewImage: "",
			isImageModalOpen: false,
			addques: false,
			dirtyMcqQuestion: false,
			editorOption: {
				modules: {
					toolbar: "#toolbar",
				},
			},
			LoaderStatus: false,
			questionType: "MCQ's",
			file: "",
			selected: "A",
			moreOption: false,
			showdatacard: false,
			overlayOpacity: 0.46,
			overlayBlur: "4",
			editshowdatacard: false,
			sectionmodal: false,
			showansweroptions: false,
			modalShow: true,
			editModal: false,
			deleteModal: false,
			qbdropdiff: false,
			singletick: false,
			checkMedia: false,
			attachdocs: false,
			autoCorrection: false,
			createnew: false,
			required: false,
			addToPublic: false,
			addToDatabank: false,
			check: true,
			editConfirm: false,
			clone: {},
			adddatatype_selected: [],
			questagmore: true,
			adddataoptions: [
				{
					value: true,
					text: "Add to Data Bank",
				},
				{
					value: true,
					text: "Add to Public",
				},
			],
			options: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],
			showoptionImageicons: null,
			optionPreviews: [],
		};
	},
	components: {
		Media,
		QuillEditor,
	},
	props: {
		data: Object,
		showindex: Number,
		isLocked: Boolean,
	},
	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		questionTags() {
			if (this.questagmore) {
				return this.data.questionTags.slice(0, 6);
			} else {
				return this.data.questionTags;
			}
		},
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
		}),
		...mapGetters(["roles"]),
		cssForDynamicColor() {
			const randomColor =
				"#" +
				Math.random()
					.toString(16)
					.slice(2, 8);
			return {
				"--dynamicBorderColor": randomColor,
			};
		},
	},
	filters: {
		fnName: function(value) {
			if (value.length <= 22) {
				return value.slice(0, 22) + " ";
			} else {
				return value.slice(0, 22) + "...";
			}
		},
	},
	validations: {
		clone: {
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),

				between: between(0.5, 100),
			},
			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			options: {
				$each: {
					value: {
						valueOrMediaRequired,
						maxLength: maxLength(1024),
					},
				},
			},
		},
	},
	created() {
		this.copyingVal();
	},
	methods: {
		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		async uploadIfNeeded() {
			if (this.file) {
				return await this.uploadFileViaSocket(this.file, {
					fileName: this.file.name,
					size: this.file.size,
				});
			}
			return null;
		},
		openPreview(imageUrl) {
			this.previewImage = imageUrl;
			this.isImageModalOpen = true;
		},
		removeOptionImage(i, index) {
			this.optionPreviews.splice(index, 1, null);
			i.media = "";
			i.mediaValue = "";
		},
		previewOptionfile(event, index) {
			console.log("yup");

			const file = event.target.files[0];
			if (!file) return;

			const reader = new FileReader();
			const media = `optionMediaValue_${index}`;

			reader.onload = (e) => {
				console.log("clone", this.clone);
				let parts = file.name.split(".");
				let ext = parts[parts.length - 1];
				if (!isImage(ext)) {
					this.errorToast("Invalid media file");
					return;
				}

				// 1. Save key to media field for display reference
				this.clone.options[index].media = media;
				// 2. Store actual File in questions array using dynamic key
				this.clone[media] = file;

				// Optional: if you want preview in template
				// this.questions.options[index].mediaPreview = e.target.result;
				// Ensure optionPreviews has enough length
				while (this.optionPreviews.length <= index) {
					this.optionPreviews.push(null);
				}

				// Replace at correct index
				this.optionPreviews.splice(index, 1, e.target.result);
				this.clone.options[index].value = "";
				this.$forceUpdate();
			};

			reader.readAsDataURL(file);

			// Clear input so same file can be re-uploaded
			event.target.value = "";
		},
		validateMarks(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		validateText(val) {
			this.dirtyMcqQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.clone.question = newContent;
		},
		changedaddQues(newval) {
			this.addques = newval;
		},
		getDesiredContent() {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = this.clone.question;
			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;
			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}
			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});
			this.clone.question = tempDiv.innerHTML;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},
		closelongEditmModal() {
			if (!this.LoaderStatus) {
				this.$bvModal.hide("confirm-edit-modal");
			}
		},
		isImage,
		isAudio,
		isVideo,
		hideshowcard() {
			this.editshowdatacard = false;
			this.qbdropdiff = false;
		},
		hidediffoptions() {
			this.qbdropdiff = false;
		},
		previewFile: function(event) {
			let mediaType = event.target.id;
			let input = event.target;
			if (input?.files?.[0]) {
				let reader = new FileReader();
				// FOR storing the FILE OBJECT value of a uploaded FILE

				reader.onload = (e) => {
					// FOR storing the binary value of a FILE
					this.clone.questionMedia = e.target.result;
					this.$forceUpdate();
				};
				reader.readAsDataURL(input.files[0]);

				// FOR getting the extension of a particular file
				let parts = input.files[0].name.split(".");
				let ext = parts[parts.length - 1];
				this.clone.questionMediaType = ext;

				// FOR Checking if the fileType is valid or NOT
				if (
					(mediaType == "file-upload-imageedit" &&
						isImage(this.clone.questionMediaType)) ||
					(mediaType == "file-uploadedit" &&
						isAudio(this.clone.questionMediaType)) ||
					(mediaType == "file-upload-videoedit" &&
						isVideo(this.clone.questionMediaType))
				) {
					this.file = input.files[0];
					this.videoData = {
						name: this.file.name,
						size: this.file.size,
					};
					this.clone.isFailed = false;
					this.$bvModal.hide("attachdocs");
					this.checkMedia = true;
				} else {
					// FOR storing the FILE OBJECT Copy of the uploaded FILE
					this.clone.isFailed = true;
					this.checkMedia = false;
					this.file = "";
					delete this.clone.questionMedia;
					delete this.clone.questionMediaType;
				}
			}
			event.target.value = "";
		},
		scrollToRight() {
			const scrollContainer = document.getElementById("addcontainer-tag-edit");
			scrollContainer.scrollTo({
				top: 0,
				left: scrollContainer.scrollWidth,
				behavior: "smooth",
			});
		},
		addquestiontag() {
			const el1 = document.getElementById("add-tag-edit");
			el1.addEventListener("click", this.scrollToRight, false);
		},
		// Edit Api
		confirm() {
			this.LoaderStatus = true;
			this.addques = true;
			this.check = false;
			this.UpdateData();
		},
		createNew() {
			this.createnew = true;
		},
		async createwithout() {
			await this.addQuestion();
			this.check = false;
			await this.deleteFromTest(false);
			this.check = true;
		},
		async createwith() {
			await this.addQuestion();
			this.$emit("question-added");
		},

		async addQuestion() {
			this.processQuestionTags();
			this.$v.$touch();
			this.removeKeys();
			this.clone.questionType = "MCQU";
			const single = this.countSelectedOptions();

			if (single === 0) {
				this.handleOptionError();
			} else {
				this.single = false;
				this.erroroption = false;
			}

			if (!this.singletick && !this.$v.$invalid) {
				const form = this.createFormData();

				const res = await postMCQquestionv2(form);

				if (res.status === 200) {
					this.handleSuccess();
				} else {
					this.handleError();
				}
			}
		},

		processQuestionTags() {
			this.clone.questionTags = this.clone.questionTags.map((s) =>
				s[0] === "#" ? s.slice(1) : s
			);
		},

		removeKeys() {
			delete this.clone.questionKey;
			delete this.clone.licenseKey;
		},

		countSelectedOptions() {
			return this.clone.options.filter((option) => option.check).length;
		},

		handleOptionError() {
			this.singletick = true;
			this.erroroption = true;
		},

		createFormData() {
			const form = new FormData();

			for (const [key, value] of Object.entries(this.clone)) {
				this.handleFormData(key, value, form);
			}
			if (this.file) {
				form.append("questionMedia", this.file);
				form.append("questionMediaType", this.clone.questionMediaType);
			} else if (!this.clone.questionMedia) {
				form.append("delete", 1);
			}

			form.append("sectionID", this.selectedSection.sectionID);
			form.append("testID", this.selectedSection.testID);

			return form;
		},

		handleFormData(key, value, form) {
			if (
				key === "questionMedia" ||
				key === "questionMediaType" ||
				key === "questionMediaPath" ||
				key === "questionFile" ||
				key === "file" ||
				key === "fileMeta"
			) {
				return;
			} else if (key === "options" || key === "questionTags") {
				this.handleArrayData(key, value, form);
			} else {
				form.append(key, value);
			}
		},

		handleQuestionMedia(key, value, form) {
			if (this.file === "" && value === "") {
				delete this.clone.questionMedia;
				delete this.clone.questionMediaType;
				form.set("delete", 1);
			} else if (this.file === "" && value !== "") {
				return;
			} else {
				form.append(key, this.file);
			}
		},

		handleArrayData(key, value, form) {
			this.clone[key] = JSON.stringify(value);
			form.append(key, this.clone[key]);
			this.clone[key] = JSON.parse(this.clone[key]);
		},

		handleSuccess() {
			this.LoaderStatus = false;
			this.check = true;
			this.editConfirm = false;
			this.createnew = false;
			this.successToast("Question added successfully!");
		},

		handleError() {
			this.errorToast("Something went wrong!");
		},

		async createFormDataUpdate() {
			let form = new FormData();
			let key = "";
			let questiontags = this.clone.questionTags.map((s) =>
				s[0] == "#" ? s.slice(1) : s
			);

			for (key in this.clone) {
				if (key === "questionMedia") {
					// 1. user removed media
					if (!this.file && this.clone.questionMedia === "") {
						form.set("delete", 1);
						continue;
					}

					// 2. user kept existing media
					if (!this.file && this.clone.questionMedia !== "") {
						continue;
					}

					// 3. user selected NEW media
					if (this.file) {
						const bucketPath = await this.uploadIfNeeded();
						if (bucketPath) {
							form.append("questionMediaPath", bucketPath);
							form.append("questionMediaType", this.clone.questionMediaType);
						}
						continue;
					}
				} else if (key === "options") {
					this.clone[key] = JSON.stringify(this.clone.options);
					form.append(key, this.clone[key]);
					this.clone[key] = JSON.parse(this.clone[key]);
				} else if (key === "questionTags") {
					form.append(key, JSON.stringify(questiontags));
				} else form.append(key, this.clone[key]);
			}

			form.append("sectionID", this.selectedSection.sectionID);
			form.append("testID", this.selectedSection.testID);
			form.append("check", this.check);

			return form;
		},

		async UpdateData() {
			if (this.file) {
				this.showVideoUploading = true;
			}
			this.showSpinner = true;
			this.commonUpdateLogic();

			if (this.singletick || this.$v.$invalid) {
				return;
			}

			if (this.dirtyMcqQuestion) {
				this.errorToast("Please fill all the mandatory fields");
				return;
			}

			try {
				const form = await this.createFormDataUpdate();
				this.file = "";
				const res = await putMCQquestionv2(form);

				if (res.status == 200) {
					this.handleUpdateSuccess();
					this.showVideoUploading = false;
					this.showSpinner = false;
					this.progress = 0;
					this.videoData = {};
				} else if (res.status == 409) {
					this.editConfirm = true;
				} else {
					this.handleError();
				}
			} catch (error) {
				if (error.response && error.response.status == 409) {
					this.editConfirm = true;
				} else {
					this.handleError();
				}
			} finally {
				this.closeEditmodal();
			}
		},

		commonUpdateLogic() {
			this.questionType = "MCQU";
			let single = 0;
			this.$v.$touch();

			for (let i in this.clone.options) {
				if (this.clone.options[i].check) {
					single += 1;
				}
			}

			if (single == 0) {
				this.singletick = true;
			}

			if (!this.clone["required"]) {
				this.clone.required = false;
			}
		},
		handleUpdateSuccess() {
			this.check = true;
			this.LoaderStatus = false;
			this.editConfirm = false;
			this.createnew = false;
			this.showansweroptions = false;
			this.successToast("Question updated successfully!");
			this.$emit("question-added");
			this.addques = false;
		},

		changequestagmore() {
			this.questagmore = !this.questagmore;
			this.$forceUpdate();
		},
		hashtag() {
			let str = document.getElementById("input-tag-edit").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("input-tag-edit").value = tagged;
		},

		copyingVal() {
			this.data.questionTags = this.data.questionTags.map((s) =>
				s[0] != "#"
					? s.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1")
					: s
			);
			this.moreOption = false;
			this.clone = JSON.parse(JSON.stringify(this.data));
			for (let j in this.data.config) {
				if (
					this.data.config[j].testID == this.selectedSection.testID &&
					this.data.config[j].SectionID == this.selectedSection.sectionID
				) {
					this.clone.required = this.data.config[j].config.required;
					this.clone.autoCorrection = this.data.config[j].config.autoCorrection;
				}
			}
			this.optionPreviews = this.clone.options.map((opt) => opt.media || "");
			if ("questionMedia" in this.clone) {
				this.checkMedia = true;
			} else {
				this.checkMedia = false;
			}
		},
		// Delete function
		deleteMcq() {
			if (this.selected == "A") {
				this.deleteFromTest(true);
			} else {
				this.deleteFromTestAndDataBank();
			}
		},
		// delete From Test Only
		async deleteFromTest(flag) {
			let payload = {
				testID: this.selectedSection.testID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				marks: this.data.marks,
			};
			const res = await deleteTestQuesData(payload);
			if (res.status == 200) {
				if (flag) {
					this.successToast("Question deleted successfully!");
					this.$emit("question-deleted");
					this.$emit("get-sections");
				}
			} else {
				this.errorToast("Something went wrong!");
			}

			//close delete modal
			this.closedeletemodal();
		},
		// delete From Test And DataBank
		async deleteFromTestAndDataBank() {
			let payload = {
				testID: this.selectedSection.testID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				marks: this.data.marks,
				addToDatabank: false,
			};
			const res = await deleteMCQquestion(payload);
			if (res.status == 200) {
				this.$emit("question-deleted");
				this.$emit("get-sections");
				this.successToast("Question deleted successfully!");
			} else {
				this.errorToast("Something went wrong!");
			}

			//close delete modal
			this.closedeletemodal();
		},

		icheck() {
			this.singletick = false;
			// for (let j in this.clone.options) {
			//   if (this.clone.options[j].check) {
			//     this.clone.options[j].check = false;
			//   }
			// }
			// i.check = !i.check;
		},
		//close delete modal
		closedeletemodal() {
			this.$bvModal.hide("deleteTopicModal");
		},
		//close Edit modal
		closeEditmodal() {
			this.dirtyMcqQuestion = false;
			this.moreOption = false;
			this.$bvModal.hide("modal-mcq-add");
		},
		// clear image
		removeMedia() {
			this.clone.questionMedia = "";
			this.clone.questionMediaType = "";
			this.clone.questionMediaPath = "";
			this.checkMedia = false;
			this.file = null;
			this.$forceUpdate();
		},
		// Adding options
		addOptions() {
			if (this.clone.options.length >= 8) {
				this.moreOption = true;
			} else {
				this.moreOption = false;
			}
			if (!this.moreOption) {
				this.clone.options.push({
					value: "",
					media: "",
					check: false,
					mediaValue: "",
				});
			}
			this.$nextTick(() => {
				const modalContent = this.$refs.mcqModalContent;
				if (modalContent) {
					const scrollToOptions = {
						top: modalContent.scrollHeight,
						behavior: "smooth",
					};

					modalContent.scrollTo(scrollToOptions);
				}
			});
		},
		// Delete options
		deleteOptions(index) {
			this.clone.options.splice(index, 1);
			this.optionPreviews.splice(index, 1); // Keep previews synced
			this.moreOption = false;
			this.$forceUpdate();
		},
		//close upload images modal
		closeattachdocsmodal() {
			this.$bvModal.hide("attachdocs");
		},
		resetModal() {
			this.moreOption = false;
			this.clone.isFailed = false;
		},
	},
};
</script>

<style scoped>
.xMarkCancel-confirm {
	position: absolute;
	top: -25px;
	right: -25px;
	border-radius: 50px;
	height: 25px;
	width: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #72738e;
	cursor: pointer;
}
.mcqcard-colorbar {
	width: 4px;
	border-radius: 2px;
	margin: 3px;
	background: #3dd695;
}
.display-mcqcard-mark-tag {
	padding: 2px 25px;
	border-radius: 6px 0px 0px 0px;
	position: absolute;
	background: #3dd695;
	bottom: 0px;
	right: 0;
}
.uploaded-option-imagecard {
	width: 100px;
	height: 100px;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 4px;
	display: flex;
}
.uploaded-option-image {
	width: 100px;
	height: 100px;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 4px;
	position: absolute;
	left: 0px;
	top: 43px;
}

.mcq-image-option-hovered-icons {
	position: absolute;
	top: 35px;
	left: 16px;
}
.mcq-radio-option-image {
	right: 10px;
	position: absolute;
	bottom: 5px;
}
.h-150px {
	height: 150px !important;
}
.mt-40px {
	margin-top: -47px;
}
.mcq-image-option-hovered-icons {
	position: absolute;
	top: 35px;
	left: 16px;
}
</style>
